export default __webpack_public_path__ + "93c96dce795f09a935890bbfd89c70e9.png";